import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {UnitsModel} from '../../../../models/UnitsModel';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {UnitsAnagrafService} from '../../../general-services/service-units-anagraf/units-anagraf.service';
import * as toastr from 'toastr';
import {RegionModel} from '../../../../models/RegionModel';

@Component({
  selector: 'app-edit-units-anagraf',
  templateUrl: './edit-units-anagraf.component.html',
  styleUrls: ['./edit-units-anagraf.component.scss']
})
export class EditUnitsAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  units: UnitsModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  saveSubscribe: Subscription;
  parameterSubscribe: Subscription;

  idUnit: number;
  codUnit: string;
  unitsJson: any;
  description: any;
  submitted: boolean;


  constructor(private route: ActivatedRoute, private router: Router,
              private unitsService: UnitsAnagrafService, private _Activatedroute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.unitsJson = params['row'];
      });

    this.units = new UnitsModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });

    this.units = JSON.parse(this.unitsJson) as UnitsModel;

    this.formValidator.patchValue({
      cod: this.units ? this.units.cod : ''
    });

    this.formValidator.patchValue({
      description: this.units ? this.units.description : ''
    });


    _Activatedroute.params.subscribe(params => {
      this.idUnit = params['id'];
      this.codUnit = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.UNITS_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.units.cod = this.formValidator.controls['cod'].value;
      this.units.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.unitsService.update(this.unitsService.baseUrl, this.units).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Units Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Unit was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.UNITS_ANAGRF]);
          }
        }, error => {
          toastr.error('Unit was not added', 'Error');
        }
      );
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
